export default __webpack_public_path__ + "static/media/Azure_logo.f24b8ca2.svg";